import myMarked from 'marked';
import hljs  from 'highlight.js'
// Set options
// `highlight` example uses `highlight.js`
myMarked.setOptions({
  renderer: new myMarked.Renderer(),
  highlight: function(code, style) {
    if((!style || style === 'bash') && code && code.split('\n').filter(s => s).length === 1) {
      return code;
    }
    return hljs.highlightAuto(code).value;
  },
  pedantic: false,
  gfm: true,
  tables: true,
  breaks: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
  xhtml: false
});

export default myMarked;